<!--
 * @Author: zhaoyang
 * @Date: 2020-10-29 10:42:36
 * @LastEditors: your name
 * @LastEditTime: 2020-10-29 16:45:48
 * @Description: 取消订单
-->
<template>
  <div class="explain-popup">
    <dl class="explain-context">
      <dt>
        陪玩師可對未完成或有爭議的訂單進行全部或局部退款，且不需經過下單用戶同意。
      </dt>
      <dd>
        <span>1.</span
        >局部退款時，已經完成的訂單會累計到陪玩師接單數，但不計入質量分評測。
      </dd>
      <dd><span>2.</span>所有退款訂單不計算「滿贈」部分，只能退實際下單數。</dd>
      <dd>
        <span>3.</span
        >若訂單使用「優惠券」，則在全部訂單退款時，退還優惠券；局部退款時，不退還優惠券。
      </dd>
      <dd><span>4.</span>所有退款訂單不計算「爽爽賺佣金」。</dd>
      <dd><span>5.</span>退款後的訂單不可評論。</dd>
    </dl>
    <div class="refound-footer">
      <div class="refound-submit" @click="handleOrderRound">返回申請退款</div>
    </div>
  </div>
</template>

<script>
import popupMixin from '@/components/common/popup/general.js';
export default {
  mixins: [popupMixin],
  methods: {
    handleOrderRound() {
      this.$emit('handleRoundExplain', 'borderRound');
    },
  },
};
</script>

<style lang="scss" scoped>
.refound-footer {
  width: 375px;
  bottom: 0;
  left: 0;
  padding: 0 16px 30px;
  position: absolute;
}
.explain-popup {
  max-height: 550px;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}
.explain-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 63px;
  padding: 0 20px;
  border-bottom: 1px solid #e8eaee;
  font-weight: 500;
  font-size: 18px;
}
.close-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  font-weight: 900;
  background: rgba(249, 249, 249, 0.78);
  color: rgba(0, 0, 0, 0.3);
}
.explain-context {
  padding: 0 20px 60px;
  font-size: 14px;
  line-height: 20px;
  color: #222c43;
  dt {
    margin-bottom: 8px;
    font-weight: 600;
  }
  dd {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    margin-bottom: 16px;
    span {
      margin-right: 6px;
    }
  }
}
.refound-submit {
  width: 100%;
  height: 48px;
  text-align: center;
  line-height: 48px;
  font-weight: 500;
  font-size: 16px;
  border-radius: 25px;
  @include button-yellow;
  font-weight: 400;
}
</style>
